export const getRequestObject = (requestData) => {
  return requestData
}
